import en from './en-US';
import es from './es-CO';
 
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  ...en,
  ...es,
};